import type {Heading} from '@diplodoc/transform/lib/typings';

import {PageTocItem} from '../models';

export function prepareHeadings(headings: Heading[]): PageTocItem[] {
    let res: PageTocItem[] = [];

    headings.forEach((item) => {
        res.push({
            depth: item.level as PageTocItem['depth'],
            anchor: item.href.slice(1),
            value: item.title,
            type: 'heading',
        });

        if (item.items) {
            res = res.concat(prepareHeadings(item.items));
        }
    });

    return res;
}
